import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import formatCurrency from "../../../common/helpers/formatCurrency";
import formatNumber from "../../../common/helpers/formatNumber";
import { VatPercentCategory } from "../utils";

interface Props {
  vatSum: VatPercentCategory;
}

const InvoiceVatValueString = ({ vatSum }: Props) => {
  const { t } = useTranslation("invoices");

  return (
    <>
      {formatCurrency(vatSum.vatAmount.toString())}
      <Typography component="span">
        {` (${formatNumber(vatSum.vatExcludedAmount.toString())} ${t(
          "euroUnit",
        )})`}
      </Typography>
    </>
  );
};

export default InvoiceVatValueString;
